import { createAction } from 'redux-actions';

const toggleSidebar = createAction('TOGGLE_SIDEBAR');

const setRef = createAction('SET_REF');
const clearRef = createAction('CLEAR_REF');

const uiActions = {
  toggleSidebar,
  setRef,
  clearRef
};

export default uiActions;
